module.exports = require("@swa-ui/core/src/Image/Image.module.scss");